import { registerAction } from '../../Action'

const LOAD_VIEW_DATA_BY_LIST = 'LOAD_VIEW_DATA_BY_LIST'

const reducer = (state = {}, action) => {
  const previousViewDataByList = state.viewDataByList || {}
  const incomingIndices = action.payload.ids
  const view = action.payload.view
  const entityType = action.payload.type
  let finalIndices = incomingIndices

  if (action.payload.append) {
    const previousIndicesForView = previousViewDataByList[view] || {}
    const previousIndicesByType = previousIndicesForView[entityType] || []

    finalIndices = [...previousIndicesByType, ...incomingIndices]
  }

  return {
    ...state,
    viewDataByList: {
      ...previousViewDataByList,
      [view]: {
        ...previousViewDataByList[view],
        [entityType]: finalIndices,
      },
    },
  }
}

const loadViewDataByList = registerAction(LOAD_VIEW_DATA_BY_LIST, { reducer })

export default loadViewDataByList
